<template>
	<v-container class="maxw-40">
		<app-feedback type="info" :closeable="false"
			>Enter your email address and we will send you a link to reset your password.</app-feedback
		>
		<v-card class="pa-5">
			<v-form @submit.prevent="submit" v-model="formIsValid">
				<v-text-field v-model="email" label="Email" :rules="emailValidationRules" validate-on-blur />
				<div class="d-flex justify-end">
					<v-btn rounded type="submit" color="primary">Submit</v-btn>
				</div>
			</v-form>
			<div class="text-center text-muted mt-5">
				Back to
				<router-link :to="{ name: 'auth-login' }">Sign in</router-link>
			</div>
		</v-card>
		<transition name="fade">
			<app-feedback v-if="status" class="mt-5" @closed="status = null" :type="status.type">{{
				status.message
			}}</app-feedback>
		</transition>
	</v-container>
</template>

<script>
import appFeedback from '@/components/common/Feedback.vue';
import soilApiService from '../../services/soilApiService';
import { emailValidationRules } from '../../utils/rules';

export default {
	components: {
		appFeedback,
	},
	data() {
		return {
			formIsValid: true,
			status: null,
			email: '',
			emailValidationRules,
		};
	},
	created() {
		const { email } = this.$route.query;
		this.email = email;
	},
	methods: {
		async submit() {
			if (!this.formIsValid) {
				return;
			}

			this.status = null;

			try {
				await soilApiService.requestPasswordReset({ email: this.email.trim() });

				this.status = {
					type: 'success',
					message: `Check your inbox: ${this.email}`,
				};
			} catch (error) {
				this.status = {
					type: 'error',
					message: 'An error has occurred. Please confirm your email is correct and try again.',
				};
			}
		},
	},
};
</script>
